import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-search-more',
  templateUrl: './search-more.component.html',
  styleUrls: ['./search-more.component.scss']
})
export class SearchMoreComponent implements OnInit {

  @Input() code: string;

  constructor() { }

  ngOnInit(): void {
  }

}
